module.exports = __webpack_public_path__ + "img/ic_apolices.296b3e65.svg";